import { Lead } from '@percihealth/react';
import AvivaReferralForm from './AvivaReferralForm';
import { AvivaReferralNextSteps } from './AvivaReferralNextSteps';

export default function Referral() {
  return (
    <>
      <main className="grid-outer main">
        <Lead title="Aviva patient referral">
          <p>
            If you would like to refer your patients to Perci Health please fill
            out the form below.
          </p>
          <p>
            To make a referral, you will need access to the patient's key
            details.
          </p>
          <p>All details provided are encrypted and stored securely by us.</p>
        </Lead>
        <AvivaReferralForm />
      </main>
      <AvivaReferralNextSteps />
    </>
  );
}
